<div><b class="jmSecondaryForeground">Description</b><i *ngIf="currentUserPersonId === resourcePersonId" (click)="onEdit()" class="fa-solid fa-pencil jmBtnText" style="margin-left: 5px;"></i></div>

<div style="padding: 0 0 10px 0">
	<div *ngIf="!isEditMode">
		<div *ngIf="description === undefined || description == null || description.length === 0">No description available</div>
		<div *ngIf="description.length > 0"> {{ (showFullText || description.length <= numTextSlice) ? description : (description | slice:0:numTextSlice) + '...' }}<span *ngIf="(description.length > numTextSlice)" (click)="showFullText = !showFullText" class="jmBtnText" style="margin-left: 10px;">{{ showFullText ? 'Show Less' : 'Show More' }}</span></div>
	</div>

	<div *ngIf="isEditMode">
		<!--<input type="text" [(ngModel)]="description" placeholder="Enter Description Here" [maxlength]="numMaxChars" class="form-control" style="background-color: #efedf1;" />-->
		<div style="display: flex; justify-content: center; margin-bottom: 5px;">
			<textarea placeholder="Enter Description" [(ngModel)]="description" [maxlength]="numMaxChars" class="form-control" style="background-color: #efedf1; height: 150px; width: 98%;" (keydown)="handleArrowKeys($event)"></textarea>
		</div>


		<div style="">{{numMaxChars - description.length}} Characters remaining</div>
		<div style="display: flex; justify-content: space-between; padding: 10px 0 10px 0">
			<button class="btn btn-lg btn-outline-primary" (click)="onCancel()" style="margin-right: 10px; flex: 1;">Cancel</button>
			<button class="btn btn-lg btn-primary" (click)="onSave()" style="margin-left: 10px; flex: 1;">Save</button>
		</div>
	</div>
</div>
